import { CSSProperties } from 'react';
import * as svgs from '../../../assets/svg';
import { IconSizeType, SvgFileNameType } from '../../../interfaces/Element.interfaces';
import { getIconWidthHeight } from '../../../utils/getter/getIconWidthHeight';

export interface IconProps {
  name: SvgFileNameType;
  // TODO: width, height 삭제 및 모든 아이콘의 크기는 size prop으로 관리 / https://gint-team.atlassian.net/browse/PVM-1770
  width?: number;
  height?: number;
  size?: IconSizeType;
  fill?: string;
  style?: CSSProperties;
}

export const Icon = ({ name, width = 24, height = 24, size, fill, style }: IconProps) => {
  const SVG = svgs[name];

  const iconWidthHeight = size ? getIconWidthHeight(size) : { width, height };

  return <SVG width={iconWidthHeight.width} height={iconWidthHeight.height} fill={fill ?? 'none'} style={style} />;
};
